import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import * as Parse from 'parse';
@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss']
})
export class ConfigComponent implements OnInit {
  terms = '';
  privacy = '';
  consent = '';
  loading = false;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: '70vh',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  sanitize: false,
  toolbarPosition: 'top',
  toolbarHiddenButtons: [
    ['bold', 'italic'],
    ['fontSize','insertImage',
      'insertVideo', 'customClasses']
  ]
}
@ViewChild('tabGroup') tabGroup;
constructor() { }

async ngOnInit(): Promise<void> {
  this.loading = true;
  await Parse.Cloud.run('getTerms').then(res => {
    this.terms = res.get('termsAndConditions')
  });
  await Parse.Cloud.run('getPrivacyPolicy').then(res => {
    this.privacy = res.get('privacyPolicy')
  });
  await Parse.Cloud.run('getCustomerConsent').then(res => {
    this.consent = res.get('customerConsent')
  });
  this.loading = false;
}

saveTerms(terms): void {
  this.loading = true;
  Parse.Cloud.run('saveTerms', { terms }).then(res => {
    this.terms = res.get('termsAndConditions')
    this.loading = false;
  });
}
savePrivacyPolicy(privacy): void {
  this.loading = true;
  Parse.Cloud.run('savePrivacyPolicy', { privacy }).then(res => {
    this.privacy = res.get('privacyPolicy')
    this.loading = false;
  });
}

saveCustomerConsent(consent): void {
  this.loading = true;
  Parse.Cloud.run('saveCustomerConsent', { consent }).then(res => {
    this.consent = res.get('customerConsent')
    this.loading = false;
  });
}
}
